<template>
  <div class="d-flex">
    <v-select
      v-model="type"
      :items="items"
      :prepend-icon="icon"
      hide-details
      solo-inverted
      return-object
      dense
    />
  </div>
</template>

<script>
export default {
  computed: {
    type: {
      get() {
        return this.$store.state.filters.gamingType;
      },
      set(type) {
        this.$store.commit("setGamingType", type);
      },
    },
    items() {
      return [
        { text: this.$t("all"), value: "all" },
        { text: this.$t("sports"), value: "sports" },
        { text: this.$t("casino"), value: "casino" },
      ];
    },
    icon() {
      if (this.type.value === "all") {
        return "mdi-all-inclusive";
      }

      return this.type.value === "casino" ? "mdi-dice-6" : "mdi-soccer";
    },
  },
};
</script>
